import type { ElementType, ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledCell, widthPct } from "./Table.styles";
import type { TableCellProps } from "./Table.types";

const TableCellComponent = ({
  as,
  active,
  collapsing,
  children,
  disabled,
  error,
  negative,
  positive,
  warning,
  selectable,
  singleLine,
  textAlign,
  verticalAlign,
  width,
  className,
  style,
  colSpan,
  rowSpan,
  ...rest
}: TableCellProps): ReactElement => {
  const Component = (as || "td") as ElementType;
  const pct = widthPct(width);
  return (
    <StyledCell
      as={Component}
      className={cx(
        className,
        collapsing && "is-collapsing",
        singleLine && "is-single-line",
        active && "is-active",
        negative && "is-negative",
        positive && "is-positive",
        warning && "is-warning",
        error && "is-error",
        disabled && "is-disabled",
        selectable && "is-selectable",
        verticalAlign && `vertical-align-${verticalAlign}`,
      )}
      style={style}
      $verticalAlign={verticalAlign}
      $widthPct={pct}
      colSpan={colSpan}
      $textAlign={textAlign}
      rowSpan={rowSpan}
      {...(rest as object)}
    >
      {children}
    </StyledCell>
  );
};

export const TableCell = styled(TableCellComponent)``;
